<div class="p-d-flex publication-div" *ngIf="publication" id="{{ publication.id }}">
    <div class="flag announcement-flag" *ngIf="publication.isAnAnnouncement">
        <i class="icon-f-bell"></i>
    </div>
    <div
        class="card p-shadow-3 p-my-md-3 p-mt-2"
        [ngClass]="{ unseen: !postIsSeen && publication.depth === 1, announcement: publication.isAnAnnouncement }"
        (mouseenter)="showEditPost = true"
        (mouseleave)="showEditPost = false"
        (click)="setFocusOnPost()"
    >
        <div class="border-bottom" *ngIf="publication.repostedAsAnnouncement">
            <div class="p-d-flex p-mx-3 p-mt-1 p-mb-1">
                <a [routerLink]="['/directory/profile', publication.reposterAsAnnouncement.id]" routerLinkActive="active" target="_blank">
                    <p-avatar
                        styleClass="p-my-auto avatar"
                        *ngIf="publication.reposterAsAnnouncement"
                        [image]="publication.reposterAsAnnouncement.pictureAccessLink"
                        size="small"
                        shape="circle"
                        [style]="{ 'background-color': 'var(--gray-light)' }"
                        [label]="
                            !publication.reposterAsAnnouncement.pictureAccessLink
                                ? publication.reposterAsAnnouncement.firstName.slice(0, 1) + publication.reposterAsAnnouncement.lastName.slice(0, 1)
                                : ''
                        "
                    ></p-avatar>
                </a>
                <div class="p-d-flex p-mx-3 p-mt-1 p-mb-1">
                    <a [routerLink]="['/directory/profile', publication.reposterAsAnnouncement.id]" routerLinkActive="active" target="_blank">
                        <span class="user-names-republish">
                            {{ publication.reposterAsAnnouncement.firstName }}
                            {{ publication.reposterAsAnnouncement.lastName }}
                        </span>
                    </a>
                    <span class="p-ml-1">{{ 'clubs.page.tabs.discussion.post.hasRepostedAsAnnouncement' | translate }}</span>
                    
                        <div class="d-md-flex d-none p-ml-1">
                            <span>•</span>
                        </div>
                        <div class="d-md-flex d-none p-ml-1">
                            <span>{{ publication.repostAsAnnouncementTime | dateAgo }}</span>
                        </div>
                </div>
            </div>
        </div>
        <div class="p-d-flex p-mx-3 p-mt-3">
            <div class="p-d-flex">
                <a [routerLink]="['/directory/profile', publication.owner.id]" routerLinkActive="active" target="_blank">
                    <p-avatar
                        styleClass="p-my-auto avatar"
                        *ngIf="publication.owner"
                        [image]="publication.owner.pictureAccessLink"
                        size="large"
                        shape="circle"
                        [style]="{ 'background-color': 'var(--gray-light)' }"
                        [label]="
                            !publication.owner.pictureAccessLink
                                ? publication.owner.firstName.slice(0, 1) + publication.owner.lastName.slice(0, 1)
                                : ''
                        "
                    ></p-avatar>
                </a>
                <div class="p-flex-column p-ml-2">
                    <a [routerLink]="['/directory/profile', publication.owner.id]" routerLinkActive="active" target="_blank">
                        <div class="p-d-flex user-names">
                            {{ publication.owner.firstName }}
                            {{ publication.owner.lastName }}
                        </div>
                    </a>
                    <div class="p-d-flex flex-md-row-reverse infos">
                        <div class="p-d-flex ml-md-1">
                            <span>{{ publication.creationDate | dateAgo }}</span>
                        </div>
                        <div *ngIf="postOwnerRole == clubRoles.Admin || postOwnerRole == clubRoles.Animator" class="p-d-flex p-ml-1">
                            <span>•</span>
                        </div>
                        <div class="p-d-flex ml-1 ml-md-0">
                            <span *ngIf="postOwnerRole == clubRoles.Admin"
                                ><i class="icon-f-admin icons"></i>
                                <span class="d-none d-md-inline ml-1">{{ 'clubs.page.common.admin' | translate }}</span>
                            </span>
                            <span *ngIf="postOwnerRole == clubRoles.Animator"
                                ><i class="icon-f-animateur icons"></i>
                                <span class="d-none d-md-inline ml-1">{{ 'clubs.page.common.animator' | translate }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <app-modal-publication-picture
                *ngIf="publication.pictureAccessLink != null && publication.pictureAccessLink != ''"
                [pictureAccessLink]="publication.pictureAccessLink"
            ></app-modal-publication-picture>

            <app-modal-publication-reactions-details
                *ngIf="publication.reactionsDetails != null"
                [membersAssociatedToReactions]="membersAssociatedToReactions"
                [reactionTypes]="reactionTypes"
            ></app-modal-publication-reactions-details>

            <app-gear-edit-post
                [publication]="publication"
                [showEditPost]="showEditPost"
                (onPublicationDeleted)="onPublicationDeleted()"
                (onPublicationUpdated)="onPublicationUpdated($event)"
                (onPublicationRepostedAsAnnouncement)="onPublicationRepostedAsAnnouncement($event)"
            ></app-gear-edit-post>
        </div>

        <!-- publication content -->
        <div class="publication-message d-none d-md-block" [innerHTML]="sanitizedContent"></div>
        <div class="d-md-none">
            <app-html-content-truncate [content]="sanitizedContent"></app-html-content-truncate>
        </div>

        <!-- publication content -->

        <div class="publication-picture-div" *ngIf="publication.pictureAccessLink !== null && publication.pictureAccessLink !== '' && publication.pictureAccessLink !== undefined">
            <img [src]="publication.pictureAccessLink" alt="publication" class="publication-picture" (click)="onClickOnPicture()" />
        </div>
        <app-link-preview *ngIf="publication.attachedUrl" [link]="getLinkInContent()" class="p-mt-4"></app-link-preview>

        <app-document-preview
            *ngIf="publication.attachedDocumentId"
            [documentId]="publication.attachedDocumentId"
            class="p-mt-4"
        ></app-document-preview>

        <div class="existing-reactions">
            <div class="row">
                <div class="row p-mx-0" [class.existing-reaction-modal-button]="!isFromHomeDrawer" (click)="getPostReactionsDetails()">
                    <div *ngFor="let reaction of publication.reactions | keyvalue">
                        <div *ngIf="reaction.value > 0" class="existing-reaction-item club-several-infos">
                            {{ getReactionTypeCode(reaction.key) }}
                            {{ reaction.value }}
                        </div>
                    </div>
                </div>
                <div *ngIf="hasReaction" class="existing-reaction-separator">•</div>
                <div
                    class="existing-reaction-item club-several-infos"
                    (click)="goToPostDetailPage()"
                    [ngStyle]="{ cursor: publication.commentsCount > 0 ? 'pointer' : 'default' }"
                >
                    {{
                        publication.commentsCount
                            | i18nPlural
                                : {
                                      '=0': 'clubs.page.common.card.count.none' | translate,
                                      '=1': 'clubs.page.common.card.count.one' | translate,
                                      other: 'clubs.page.common.card.count.x' | translate
                                  }
                    }}
                </div>
            </div>
        </div>
        <div class="p-d-flex new-reactions p-mt-3" *ngIf="!publication.disabled">
            <div class="p-d-flex p-mx-auto">
                <div class="publication-new-custom-reaction p-mx-auto">
                    <app-add-new-reaction
                        class="p-mr-auto"
                        (mouseenter)="hoverOnAddCustomReaction = true"
                        (mouseleave)="hoverOnAddCustomReaction = false"
                        *ngIf="hoverOnLike || hoverOnAddCustomReaction"
                        (onReactionAdded)="addOrRemoveReaction($event)"
                    ></app-add-new-reaction>
                </div>
                <add-reaction-button
                    [currentReaction]="currentUserReaction"
                    (onReactionAdded)="addOrRemoveReaction($event)"
                    (mouseenter)="hoverOnLike = true"
                    (mouseleave)="disableHoverOnLike()"
                >
                </add-reaction-button>
            </div>
            <div class="p-d-flex p-mx-auto">
                <button
                    pButton
                    pRipple
                    type="button"
                    styleClass="p-my-auto"
                    class="p-button-text p-button-plain p-my-1 p-px-xl-6 p-px-lg-6 p-px-md-4 p-px-sm-3"
                    (click)="addComment()"
                    icon="pi pi-comment"
                    label="{{ 'clubs.page.common.card.comment' | translate }}"
                ></button>
            </div>
        </div>

        <div [style.display]="areCommentsDisplayed ? 'block' : 'none'" [ngClass]="{ 'd-none d-md-block': !isPostRoute }">
            <div
                class="load-other-comments"
                *ngIf="publication.commentsCount > 0 && publication.commentsCount > comments.length"
                (click)="getComments()"
            >
                <span *ngIf="page === 1 && publication.commentsCount < 50 && publication.commentsCount >= 3">
                    {{ 'clubs.page.common.card.see' | translate }}
                    {{
                        publication.commentsCount - 2
                            | i18nPlural
                                : {
                                      '=1': 'clubs.page.common.card.postCommentCount.one' | translate,
                                      other: 'clubs.page.common.card.postCommentCount.x' | translate
                                  }
                    }}
                </span>

                
                <span *ngIf="comments.length < publication.commentsCount && publication.commentsCount > 50">
                    {{ 'clubs.page.common.card.seeMore' | translate : { length: comments.Length, count: publication.commentsCount } }}
                </span>
            </div>
            <div class="p-mt-2">
                <app-comment-card
                    *ngFor="let comment of comments"
                    [publication]="comment"
                    [parentPublicationId]="publication.id"
                    [highlightedCommentId]="highlightedCommentId"
                    (onCommentDeleted)="onCommentDeletedFunction()"
                ></app-comment-card>
            </div>
            <div *ngIf="hasSignalrFocus && peopleWrittingCommentCount > 0" class="p-ml-6">
                {{ 'clubs.page.common.card.typing' | translate }}
            </div>
        </div>

        
        <app-add-new-comment
            *ngIf="!publication.disabled"
            [ngClass]="{ 'd-none d-md-block': !isPostRoute }"
            [publication]="publication"
            [initOnCommentField]="initOnCommentField"
            [initOnCommentFieldOwner]="publication.owner"
            (onCommentCreated)="onAddNewComment($event)"
            #addNewCommentComponent
        ></app-add-new-comment>
    </div>
    <div class="flag mention-flag" *ngIf="isCurrentMemberMentioned()">
        <i class="icon-o-mention"></i>
    </div>
</div>
